export const PACKAGE_NAME = '@atlassian/jira-recommend-premium-to-standard-modal';
export const TEAM_NAME = 'growth-tako';
export const ANALYTICS_SOURCE_NAME = 'recommendPremiumToStandard';
